/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */
export function CollapseNumberRange(result) {
  return result;
}